export default "__VITE_ASSET__50a5238b__"